import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from '@material-ui/core';

type AutoNextDialModalProps = {
  open: boolean;
  leadName: string;
  leadPhone: string;
  seconds?: number;
  onTimeout: () => void;
  onPause: () => void;
};

const AutoNextDialModal: React.FC<AutoNextDialModalProps> = ({
  open,
  leadName,
  leadPhone,
  seconds = 5,
  onTimeout,
  onPause,
}) => {
  const [remaining, setRemaining] = useState(seconds);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!open) return;

    setRemaining(seconds);
    if (timerRef.current) window.clearInterval(timerRef.current);

    timerRef.current = window.setInterval(() => {
      setRemaining((s) => {
        if (s <= 1) {
          if (timerRef.current) window.clearInterval(timerRef.current);
          onTimeout();
          return 0;
        }
        return s - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) window.clearInterval(timerRef.current);
    };
  }, [open, seconds, onTimeout]);

  return (
    <Dialog
      open={open}
      onClose={onPause}
      aria-labelledby="auto-next-dial-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="auto-next-dial-title"
        style={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 600 }}
      >
        Auto Dialer
      </DialogTitle>

      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          p={2}
        >
          <Typography variant="h6" gutterBottom>
            {leadName}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" gutterBottom>
            {leadPhone}
          </Typography>

          <Box mt={3}>
            <Typography variant="h5">
              Calling the next contact in{' '}
              <strong>{remaining}s</strong>…
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
        <Button onClick={onPause} color="primary" variant="contained" size="large">
          Pause
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutoNextDialModal;